var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, List, ListItemButton, Typography } from "@mui/material";
/**
 * Sumário lateral do formulário que exibe as páginas e permite navegação por clique
 */
var FormTOC = function (_a) {
    var pages = _a.pages, activePage = _a.activePage, onSelectPage = _a.onSelectPage, originalPageIndices = _a.originalPageIndices, _b = _a.side, side = _b === void 0 ? "left" : _b;
    var handleClick = function (e, originalIndex) {
        e.preventDefault();
        e.stopPropagation();
        onSelectPage(originalIndex);
    };
    return (_jsx(Box, __assign({ sx: __assign(__assign({ display: { xs: "none", md: "block" }, flexShrink: 0, width: 240 }, (side === "left" ? { borderRight: 1 } : { borderLeft: 1 })), { borderColor: "divider", minHeight: "195px", maxHeight: "700px", overflowY: "auto" }) }, { children: _jsx(List, __assign({ disablePadding: true }, { children: pages.map(function (page, listIndex) {
                var _a, _b, _c;
                var originalIndex = (_a = originalPageIndices === null || originalPageIndices === void 0 ? void 0 : originalPageIndices[listIndex]) !== null && _a !== void 0 ? _a : listIndex;
                var isActive = originalIndex === activePage;
                return (_jsx(ListItemButton, __assign({ selected: isActive, onClick: function (e) { return handleClick(e, originalIndex); }, sx: {
                        py: 1.5,
                        px: 2,
                    } }, { children: _jsx(Typography, __assign({ variant: "body2", sx: {
                            fontWeight: isActive ? 600 : 400,
                            color: isActive ? "primary.main" : "text.primary",
                        } }, { children: (_c = (_b = page.navigationTitle) !== null && _b !== void 0 ? _b : page.title) !== null && _c !== void 0 ? _c : page.name })) }), "".concat(originalIndex, "-").concat(page.name)));
            }) })) })));
};
export default FormTOC;
